import { render, staticRenderFns } from "./TinabaPay.vue?vue&type=template&id=00ea67b9&"
import script from "./TinabaPay.vue?vue&type=script&lang=js&"
export * from "./TinabaPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports